export enum EmissionsReportTypes {
  CII = 'CII Predictive Tool Insite Digital',
  EUETS = 'EUETS Report',
  EUETSInternal = 'EUETS Report Internal',
  FuelEU = 'FuelEU Report',
  FuelEUInternal = 'FuelEU Report Internal',
}

export function findEmissionReportType(type: string | undefined) {
  const parsedType = parseReportTypeParam(type)
  if (!type) return
  return Object.values(EmissionsReportTypes).find((reportType) => {
    return reportType.toLowerCase() === parsedType
  })
}

export function parseReportTypeParam(reportType: string | undefined) {
  if (!reportType) return
  return reportType.replace(/-/g, ' ').toLowerCase()
}
